/*
 * Copyright (c) 2021. American Express Company
 */
/* eslint-disable @typescript-eslint/quotes */
export enum TooltipPlacement {
    TOP = 'top',
    BOTTOM = 'bottom',
    LEFT = 'left',
    RIGHT = 'right'
}
